/* Unblue Kids — interactions de la maquette v13 (menu téléphone, galerie, formats, avis, témoignages,
   compte à rebours, coffret cadeau, filtres du blog, panier). Le bouton d'ajout au panier reste celui de Dawn. */
(function () {
  'use strict';
  var H = window.UB_H = {};
  function qa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function toggle(el) {
    var open = el.hasAttribute('hidden');
    if (open) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
    return open;
  }

  // Menu téléphone
  H.toggleMenu = function (el) {
    var hdr = el.closest('header');
    var m = hdr && hdr.querySelector('[data-ub-menu]');
    if (m) el.setAttribute('aria-expanded', toggle(m) ? 'true' : 'false');
  };
  H.toggleShop = function (el) {
    var nav = el.closest('nav');
    var s = nav && nav.querySelector('[data-ub-shop]');
    if (!s) return;
    var open = toggle(s);
    el.setAttribute('aria-expanded', open ? 'true' : 'false');
    var svg = el.querySelector('svg');
    if (svg) svg.style.transform = 'rotate(' + (open ? '180deg' : '0deg') + ')';
  };

  // Galerie (page produit et coffret)
  H['t.pick'] = function (el, i) {
    var sec = el.closest('section');
    if (!sec) return;
    var main = sec.querySelector('[data-ub-main]');
    var im = el.querySelector('img');
    if (main && im) {
      main.src = im.src.replace(/([?&])width=\d+/, '$1width=1100');
      main.alt = el.getAttribute('aria-label') || '';
    }
    qa('[data-ub-on="click:t.pick"]', sec).forEach(function (b, k) {
      b.style.border = k === i ? '3px solid #6C4CF5' : '2px solid #22184A';
    });
  };

  // Formats : choisit la variante dans le formulaire de Dawn (le bouton lui-même n'est pas touché)
  function pickFormat(sec, i, keepUrl) {
    var tiles = qa('[data-ub-on="click:f.pick"]', sec);
    var t = tiles[i];
    if (!t) return;
    tiles.forEach(function (b, k) {
      var on = k === i;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.style.background = on ? '#FFF3CC' : '#FFFFFF';
      b.style.border = on ? '3px solid #22184A' : '2px solid #22184A';
      b.style.boxShadow = on ? '0 4px 0 #22184A' : 'none';
    });
    var note = sec.querySelector('[data-ub-fmt-note]');
    if (note) note.textContent = t.getAttribute('data-note') || '';
    var vid = t.getAttribute('data-variant-id');
    qa('product-form form input[name="id"]', sec).forEach(function (inp) {
      if (inp.value !== vid) {
        inp.value = vid;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    if (!keepUrl) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', vid);
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (e) {}
    }
  }
  H['f.pick'] = function (el, i) {
    pickFormat(el.closest('section'), i, false);
  };

  // Petit carrousel d'avis sous les garanties
  function initReviews(w) {
    var data = [];
    try {
      data = JSON.parse(w.getAttribute('data-ub-reviews') || '[]');
    } catch (e) {}
    if (!data.length) return;
    var i = 0;
    var timer = null;
    function show(k) {
      i = ((k % data.length) + data.length) % data.length;
      var r = data[i];
      var t = w.querySelector('[data-ub-rv-text]');
      if (t) t.textContent = '“' + r.text + '”';
      var p = w.querySelector('[data-ub-rv-photo]');
      if (p) p.src = r.photo;
      var who = w.querySelector('[data-ub-rv-who]');
      if (who) who.textContent = r.who;
      qa('[data-ub-rv-dot]', w).forEach(function (d, k2) {
        d.style.width = k2 === i ? '22px' : '8px';
        d.style.background = k2 === i ? '#22184A' : '#CFC6EA';
      });
    }
    function restart() {
      clearInterval(timer);
      timer = setInterval(function () {
        show(i + 1);
      }, 6000);
    }
    w._ubStep = function (d) {
      show(i + d);
      restart();
    };
    restart();
  }
  H.rvPrev = function (el) {
    var w = el.closest('[data-ub-reviews]');
    if (w && w._ubStep) w._ubStep(-1);
  };
  H.rvNext = function (el) {
    var w = el.closest('[data-ub-reviews]');
    if (w && w._ubStep) w._ubStep(1);
  };

  // Témoignages avec photos
  function track(el) {
    var sec = el.closest('section');
    return sec && sec.querySelector('[data-ub-ref="setTRef"]');
  }
  H.tPrev = function (el) {
    var t = track(el);
    if (t) t.scrollBy({ left: -t.clientWidth * 0.85, behavior: 'smooth' });
  };
  H.tNext = function (el) {
    var t = track(el);
    if (t) t.scrollBy({ left: t.clientWidth * 0.85, behavior: 'smooth' });
  };
  function onTrackScroll(t) {
    var n = t.children.length;
    var max = t.scrollWidth - t.clientWidth;
    var i = max > 0 ? Math.round((t.scrollLeft / max) * (n - 1)) : 0;
    var sec = t.closest('section');
    var c = sec && sec.querySelector('[data-ub-tnum]');
    if (c) c.textContent = String(i + 1);
  }

  // Coffret cadeau
  H['l.pick'] = function (el, i) {
    qa('[data-ub-on="click:l.pick"]', el.parentElement).forEach(function (b, k) {
      b.style.background = k === i ? b.getAttribute('data-color') || '#FFFFFF' : '#FFFFFF';
    });
    var sec = el.closest('section');
    var s = sec && sec.querySelector('[data-ub-gb-level]');
    if (s) s.textContent = el.getAttribute('data-short') || '';
  };
  H['h.pick'] = function (el, i) {
    qa('[data-ub-on="click:h.pick"]', el.parentElement).forEach(function (b, k) {
      b.style.background = k === i ? '#FFC93C' : '#FFFFFF';
    });
  };

  // Blog : catégories
  H['c.pick'] = function (el, i) {
    qa('[data-ub-on="click:c.pick"]', el.parentElement).forEach(function (b, k) {
      b.style.background = k === i ? '#FFC93C' : '#FFFFFF';
    });
    var cat = el.getAttribute('data-cat');
    qa('[data-ub-cat]').forEach(function (c) {
      if (!c.hasAttribute('data-ub-d')) c.setAttribute('data-ub-d', c.style.display || '');
      c.style.display = i === 0 || c.getAttribute('data-ub-cat') === cat ? c.getAttribute('data-ub-d') : 'none';
    });
  };

  // Compte à rebours du bandeau (même calcul que la maquette)
  function countdown() {
    var now = Date.now();
    var end = Date.parse('2026-11-01T04:00:00Z');
    while (end <= now) end += 86400000;
    var left = end - now;
    var v = [Math.floor(left / 3600000), Math.floor(left / 60000) % 60, Math.floor(left / 1000) % 60];
    qa('[data-ub-cd]').forEach(function (s, k) {
      s.textContent = String(v[k % 3]).padStart(2, '0');
    });
  }

  // Panier : l'icône du téléphone ouvre aussi le tiroir de Dawn, et les deux compteurs suivent
  function refreshCount() {
    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        qa('[data-ub-cart-count]').forEach(function (s) {
          s.textContent = String(c.item_count);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-ub-on^="click:"]') : null;
    if (el) {
      var fn = H[el.getAttribute('data-ub-on').slice(6)];
      if (fn) {
        e.preventDefault();
        fn(el, parseInt(el.getAttribute('data-ub-i') || '0', 10), e);
      }
    }
    qa('details[data-ub-dd][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  function init() {
    countdown();
    setInterval(countdown, 1000);
    qa('[data-ub-reviews]').forEach(initReviews);
    qa('[data-ub-on="scroll:tScroll"]').forEach(function (t) {
      t.addEventListener(
        'scroll',
        function () {
          onTrackScroll(t);
        },
        { passive: true },
      );
    });
    qa('section').forEach(function (sec) {
      var inp = sec.querySelector('product-form form input[name="id"]');
      if (!inp) return;
      qa('[data-ub-on="click:f.pick"]', sec).forEach(function (b, k) {
        if (b.getAttribute('data-variant-id') === inp.value) pickFormat(sec, k, true);
      });
    });
    qa('[data-ub-cart]').forEach(function (a) {
      if (a.id === 'cart-icon-bubble') return;
      a.addEventListener('click', function (e) {
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') {
          e.preventDefault();
          d.open(a);
        }
      });
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(refreshCount, 60);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* v18: bundles, gift picker, drawer menu */
(function () {
  var H = window.UB_H;
  if (!H) return;
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function press(group, el) { group.forEach(function (b) { b.setAttribute('aria-pressed', b === el ? 'true' : 'false'); }); }
  function post(items, btn) {
    if (btn) { btn.disabled = true; btn.style.opacity = '.7'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); }).then(function () { window.location.href = '/cart'; })
      .catch(function () { if (btn) { btn.disabled = false; btn.style.opacity = '1'; } });
  }
  // Bundles on the product page
  H['b.pick'] = function (el) {
    var w = el.closest('[data-ub-bundle]'); var n = +el.getAttribute('data-n');
    press(qa('[data-ub-on="click:b.pick"]', w), el); press(qa('.ubx-lnk', w), null);
    w._fmt = null;
    var rows = w.querySelector('[data-ub-b-rows]'); rows.hidden = n < 2;
    qa('[data-ub-b-row]', w).forEach(function (r) { r.hidden = +r.getAttribute('data-ub-b-row') > n; });
    var p = el.querySelector('.ubx-opt-p'); var btn = w.querySelector('[data-ub-b-btn]');
    btn.textContent = 'Add to cart · ' + p.firstChild.textContent.trim();
  };
  H['b.lvl'] = function (el) { press(qa('button', el.parentNode), el); };
  H['b.fmt'] = function (el) {
    var w = el.closest('[data-ub-bundle]'); w._fmt = el.getAttribute('data-v');
    press(qa('[data-ub-on="click:b.pick"]', w), null); press(qa('.ubx-lnk', w), el);
    w.querySelector('[data-ub-b-rows]').hidden = true;
    w.querySelector('[data-ub-b-btn]').textContent = 'Add to cart · ' + el.textContent.replace(/^.*?\$/, '$');
  };
  H['b.add'] = function (el) {
    var w = el.closest('[data-ub-bundle]');
    if (w._fmt) return post([{ id: +w.getAttribute('data-v-' + w._fmt), quantity: 1 }], el);
    var sel = w.querySelector('[data-ub-on="click:b.pick"][aria-pressed="true"]'); var n = sel ? +sel.getAttribute('data-n') : 1;
    var tag = n > 1 ? { _bundle: n + ' missions' } : {};
    var items = [{ id: +w.getAttribute('data-v-' + w.getAttribute('data-me')), quantity: 1, properties: tag }];
    for (var k = 2; k <= n; k++) {
      var on = w.querySelector('[data-ub-b-row="' + k + '"] [aria-pressed="true"]');
      var l = on ? on.getAttribute('data-l') : w.getAttribute('data-me');
      items.push({ id: +w.getAttribute('data-v-' + l), quantity: 1, properties: tag });
    }
    post(items, el);
  };
  // Gift page
  H['g.pick'] = function (el) {
    var w = el.closest('[data-ub-gift]'); var n = +el.getAttribute('data-n');
    qa('[data-ub-g-opt]', w).forEach(function (o) { o.setAttribute('aria-pressed', +o.getAttribute('data-ub-g-opt') === n ? 'true' : 'false'); });
    w.querySelector('[data-ub-g-ages]').hidden = n === 0; w.querySelector('[data-ub-g-card]').hidden = n !== 0;
  };
  H['g.lvl'] = function (el) { press(qa('button', el.parentNode), el); };
  H['g.amt'] = function (el) {
    press(qa('button', el.parentNode), el);
    var c = el.closest('[data-ub-g-card]'); var t = c.querySelector('[data-ub-g-amt]'); if (t) t.value = '';
    c.querySelector('[data-ub-g-err]').hidden = true;
  };
  H['g.add'] = function (el) {
    var w = el.closest('[data-ub-gift]'); var sel = w.querySelector('[data-ub-g-opt][aria-pressed="true"]'); var n = sel ? +sel.getAttribute('data-ub-g-opt') : 1;
    if (n === 0) return giftCard(w.querySelector('[data-ub-g-card]'), el);
    var note = (w.querySelector('#ub-g-note') || {}).value || '';
    var items = qa('.ubx-gl-c', sel).map(function (g) {
      var on = g.querySelector('[aria-pressed="true"]');
      return { id: +w.getAttribute('data-v-' + (on ? on.getAttribute('data-l') : 'ex')), quantity: 1, properties: { 'Gift': 'Yes', 'Gift note': note } };
    });
    post(items, el);
  };
  H['g.prev'] = function (el) {
    var w = el.closest('[data-ub-gift]'); var sel = w.querySelector('[data-ub-g-opt][aria-pressed="true"]');
    var lv = qa('.ubx-gl-c', sel).map(function (g) { var on = g.querySelector('[aria-pressed="true"]'); return on ? on.getAttribute('data-l') : 'ex'; });
    var note = ((w.querySelector('#ub-g-note') || {}).value || '').slice(0, 400);
    window.open('/pages/printable-card?m=' + (lv.join(',') || 'ex') + '&n=' + encodeURIComponent(note), '_blank', 'noopener');
  };
  // Drawer menu (opens from the left, a strip stays visible on the right to close)
  H['m.open'] = function () { var d = document.querySelector('[data-ub-drawer]'); if (d) { d.hidden = false; document.documentElement.style.overflow = 'hidden'; } };
  H['m.close'] = function () { var d = document.querySelector('[data-ub-drawer]'); if (d) { d.hidden = true; document.documentElement.style.overflow = ''; } };
})();
(function () { if (location.hash === '#menu' && window.UB_H) window.UB_H['m.open'](); })();
/* "Loved by" faces: the first slides out to the left, a new one slides in from the right */
(function () {
  function run(w) {
    var i = w.querySelector('.ubx-av-i'); if (!i || i.children.length < 4) return;
    setInterval(function () {
      var step = i.children[0].getBoundingClientRect().width - 7;
      i.style.transition = 'transform .6s ease'; i.style.transform = 'translateX(' + (-step) + 'px)';
      setTimeout(function () { i.style.transition = 'none'; i.appendChild(i.children[0]); i.style.transform = 'none'; }, 650);
    }, 2600);
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-ub-av]'), run); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
/* v20: formats, notify me, cart upsell */
(function () {
  var H = window.UB_H; if (!H) return;
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var NOTE = { 0: 'PDF instantly, printed book shipped to your door', 1: 'Spiral-bound book, shipped to your door', 2: 'Instant download, print at home tonight' };
  H['fm.pick'] = function (el) {
    var w = el.closest('[data-ub-fmt]'); var opts = qa('[data-ub-on="click:fm.pick"]', w);
    opts.forEach(function (b) { b.setAttribute('aria-pressed', b === el ? 'true' : 'false'); });
    w.querySelector('[data-ub-fm-btn]').textContent = 'Add to cart · ' + el.querySelector('.ubx-opt-p').firstChild.textContent.trim();
    w.querySelector('[data-ub-fm-note]').textContent = NOTE[opts.indexOf(el)] || NOTE[0];
  };
  H['fm.notify'] = function (el) { var f = el.parentNode.querySelector('[data-ub-notify]'); if (f) { f.hidden = !f.hidden; if (!f.hidden) { var i = f.querySelector('input[type=email]'); if (i) i.focus(); } } };
  function add(id, btn, then) {
    if (btn) { btn.disabled = true; btn.style.opacity = '.7'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function () { then(); }).catch(function () { if (btn) { btn.disabled = false; btn.style.opacity = '1'; } });
  }
  H['fm.add'] = function (el) { var w = el.closest('[data-ub-fmt]'); var s = w.querySelector('[data-ub-on="click:fm.pick"][aria-pressed="true"]'); add(s.getAttribute('data-v'), el, function () { window.location.href = '/cart'; }); };
  H['cu.add'] = function (el) { add(el.getAttribute('data-v'), el, function () { window.location.reload(); }); };
})();
/* the open menu details close each other */
document.addEventListener('toggle', function (e) { var d = e.target; if (!d.classList || !d.classList.contains('ubx-lvd') || !d.open) return; Array.prototype.forEach.call(document.querySelectorAll('.ubx-lvd[open]'), function (o) { if (o !== d) o.open = false; }); }, true);

/* v27: review polaroids + photo lightbox (product gallery and reviews) */
(function () {
  'use strict';
  var H = window.UB_H || (window.UB_H = {});
  var lb, img, cap, items = [], idx = 0, last = null;
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function base(u) { return (u || '').split('?')[0]; }
  function build() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'ubx-lb'; lb.hidden = true;
    lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Photo');
    lb.innerHTML = '<button type="button" class="ubx-lb-x" aria-label="Close">&times;</button>' +
      '<button type="button" class="ubx-lb-p" aria-label="Previous photo">&#8249;</button>' +
      '<figure><img alt=""><figcaption></figcaption></figure>' +
      '<button type="button" class="ubx-lb-n" aria-label="Next photo">&#8250;</button>';
    document.body.appendChild(lb);
    img = lb.querySelector('img'); cap = lb.querySelector('figcaption');
    lb.addEventListener('click', function (e) {
      if (e.target.closest('.ubx-lb-p')) go(-1);
      else if (e.target.closest('.ubx-lb-n')) go(1);
      else if (e.target.closest('.ubx-lb-x') || !e.target.closest('figure')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
    });
  }
  function show() {
    var it = items[idx];
    img.src = it.src; img.alt = it.alt || '';
    cap.textContent = it.cap || ''; cap.hidden = !it.cap;
    var many = items.length > 1;
    lb.querySelector('.ubx-lb-p').hidden = !many;
    lb.querySelector('.ubx-lb-n').hidden = !many;
  }
  function go(d) { idx = (idx + d + items.length) % items.length; show(); }
  function open(list, i) {
    build(); items = list; idx = i; last = document.activeElement; show();
    lb.hidden = false; document.documentElement.classList.add('ubx-lb-on');
    lb.querySelector('.ubx-lb-x').focus();
  }
  function close() {
    lb.hidden = true; document.documentElement.classList.remove('ubx-lb-on');
    if (last && last.focus) last.focus({ preventScroll: true });
  }
  H['lb.rv'] = function (el) {
    var t = el.closest('.ubx-rv-t');
    var all = qa('.ubx-pol-b', t).filter(function (b) { return !b.closest('.ubx-rv-dup'); });
    var list = all.map(function (b) {
      return { src: b.getAttribute('data-src'), alt: b.querySelector('img').alt, cap: b.getAttribute('data-cap') };
    });
    var i = 0;
    for (var k = 0; k < list.length; k++) if (list[k].src === el.getAttribute('data-src')) { i = k; break; }
    open(list, i);
  };
  H['lb.main'] = function (el) {
    var sec = el.closest('section');
    var main = sec.querySelector('[data-ub-main]');
    var thumbs = qa('[data-ub-on="click:t.pick"]', sec);
    var list = thumbs.map(function (b) {
      var im = b.querySelector('img');
      var u = im.src;
      return { src: /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=1600') : u, alt: b.getAttribute('aria-label') || '' };
    });
    var i = 0;
    for (var k = 0; k < list.length; k++) if (base(list[k].src) === base(main.src)) { i = k; break; }
    open(list.length ? list : [{ src: main.src, alt: main.alt }], i);
  };
})();

/* v28: "Add" on another age inside the cart drawer refreshes the drawer in place (Dawn's renderContents); elsewhere it reloads */
(function () {
  var H = window.UB_H; if (!H) return;
  H['cu.add'] = function (el) {
    var cd = el.closest('cart-drawer');
    el.disabled = true; el.style.opacity = '.7';
    var body = { items: [{ id: +el.getAttribute('data-v'), quantity: 1 }] };
    if (cd) body.sections = 'cart-drawer,cart-icon-bubble';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (cd && j.sections && typeof cd.renderContents === 'function') { j.id = j.items && j.items[0] && j.items[0].id; cd.renderContents(j); }
        else window.location.reload();
      })
      .catch(function () { el.disabled = false; el.style.opacity = '1'; });
  };
})();

/* v30: gift card at any amount ($10-$250) + Shopify's "send to recipient" fields */
function giftCard(c, btn) {
  var map = {}; try { map = JSON.parse(c.querySelector('[data-ub-g-map]').textContent); } catch (e) {}
  var t = c.querySelector('[data-ub-g-amt]'), chip = c.querySelector('[data-ub-g-chips] [aria-pressed="true"]'), er = c.querySelector('[data-ub-g-err]');
  var amt = t && t.value !== '' ? Number(t.value) : (chip ? Number(chip.getAttribute('data-a')) : NaN);
  if (!(amt >= 10 && amt <= 250 && Math.floor(amt) === amt) || !map[amt]) { er.hidden = false; if (t) t.focus(); return; }
  var props = {};
  if (c.querySelector('[data-ub-g-to]').checked) {
    var mail = c.querySelector('#ub-g-rmail');
    if (!mail.value || !mail.checkValidity()) { mail.focus(); if (mail.reportValidity) mail.reportValidity(); return; }
    props['__shopify_send_gift_card_to_recipient'] = 'on';
    props['Recipient email'] = mail.value.trim();
    var nm = c.querySelector('#ub-g-rname').value.trim(); if (nm) props['Recipient name'] = nm;
    var msg = c.querySelector('#ub-g-rmsg').value.trim(); if (msg) props['Message'] = msg;
    var on = c.querySelector('#ub-g-ron').value; if (on) props['Send on'] = on;
    props['__shopify_offset'] = String(new Date().getTimezoneOffset());
  }
  btn.disabled = true; btn.style.opacity = '.7';
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: map[amt], quantity: 1, properties: props }] }) })
    .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
    .then(function (x) {
      if (x.ok) { window.location.href = '/cart'; return; }
      btn.disabled = false; btn.style.opacity = '1';
      er.textContent = (x.d && (x.d.description || x.d.message)) || 'Something went wrong. Please try again.'; er.hidden = false;
    })
    .catch(function () { btn.disabled = false; btn.style.opacity = '1'; });
}
(function () {
  var c = document.querySelector('[data-ub-g-card]'); if (!c) return;
  var t = c.querySelector('[data-ub-g-amt]'), er = c.querySelector('[data-ub-g-err]');
  t.addEventListener('input', function () {
    er.hidden = true; er.textContent = 'Pick a whole amount between $10 and $250.';
    if (t.value !== '') c.querySelectorAll('[data-ub-g-chips] button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
  });
  c.querySelector('[data-ub-g-to]').addEventListener('change', function (e) { c.querySelector('[data-ub-g-rcpt]').hidden = !e.target.checked; });
  var d = c.querySelector('#ub-g-ron'), now = new Date();
  function iso(x) { return new Date(x.getTime() - x.getTimezoneOffset() * 60000).toISOString().slice(0, 10); }
  d.min = iso(now); d.max = iso(new Date(now.getTime() + 89 * 86400000));
})();

/* v32: inscriptions Club et pages gratuites -> listes Klaviyo, avec le niveau de l'enfant (repli : formulaire Shopify) */
/* v34: écoute en tête de chaîne (window, capture) et arrête l'événement, sinon le captcha Shopify renvoie aussi le formulaire */
(function () {
  window.addEventListener('submit', function (e) {
    var f = e.target, list = f && f.getAttribute && f.getAttribute('data-ub-kl');
    if (!list) return;
    var em = f.querySelector('input[type="email"]'), lv = f.querySelector('[data-ub-level]') || f.querySelector('select'), fmt = f.querySelector('[data-ub-format]'), src = f.getAttribute('data-ub-src');
    if (!em || !em.value) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = f.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.style.opacity = '.7'; }
    var body = { data: { type: 'subscription', attributes: {
      custom_source: { club: 'Unblue Club page', home: 'Unblue home Mini Mission', popup: 'Unblue popup Mini Mission', 'notify-m2': 'Unblue Mission 2 notify' }[src] || 'Unblue site',
      profile: { data: { type: 'profile', attributes: {
        email: em.value.trim(),
        properties: fmt ? { kid_level: lv ? lv.value : '', signup_source: src, club_format: fmt.value } : { kid_level: lv ? lv.value : '', signup_source: src },
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: list } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=SRuBwa', {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-07-15' }, body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo ' + r.status);
      try { localStorage.setItem('ub_signed', '1'); } catch (x) {}
      var done = f.querySelector('.ub-kl-done');
      Array.prototype.forEach.call(f.children, function (ch) { if (ch !== done && ch.tagName !== 'INPUT') ch.hidden = true; });
      if (done) done.hidden = false;
    }).catch(function () {
      f.removeAttribute('data-ub-kl'); if (btn) { btn.disabled = false; btn.style.opacity = ''; }
      if (f.requestSubmit) f.requestSubmit(); else f.submit();
    });
  }, true);
})();

/* v33: popup Mini Mission (20 s ou mi-page, sortie de page sur ordinateur ; 1 fois par semaine ; jamais après une inscription) */
(function () {
  document.querySelectorAll('[data-ub-notify]').forEach(function (d) { if (!d.querySelector('input[type="email"]')) d.hidden = false; });
  var pop = document.querySelector('[data-ub-pop]');
  if (!pop) return;
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (x) { return null; } }
  var force = /[?&]ub_popup=1/.test(location.search) || (/[?&]customer_posted=true/.test(location.search) && location.hash === '#ub-pop-form'), shown = false;
  if (!force && (ls('ub_signed') || Date.now() - (+ls('ub_pop_seen') || 0) < 7 * 864e5)) return;
  function show() {
    if (shown) return; shown = true; ls('ub_pop_seen', String(Date.now()));
    pop.hidden = false; document.documentElement.style.overflow = 'hidden';
    var i = pop.querySelector('input[type="email"]'); if (i) setTimeout(function () { i.focus(); }, 60);
  }
  function hide() { pop.hidden = true; document.documentElement.style.overflow = ''; }
  pop.addEventListener('click', function (e) { if (e.target.closest('[data-ub-pop-x]')) hide(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) hide(); });
  if (force) { show(); return; }
  setTimeout(show, 20000);
  window.addEventListener('scroll', function () { var h = document.documentElement; if ((h.scrollTop + innerHeight) / h.scrollHeight > 0.5) show(); }, { passive: true });
  document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 10 && matchMedia('(pointer: fine)').matches) show(); });
})();
